<template>
  <v-container fluid class="route-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Route</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Route</p>
                        <v-text-field
                          type="number"
                          class="mb-4"
                          v-model="new_route.routenum"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Route Num"
                          persistent-hint
                          single-line hint="Enter the route num">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_route.routename"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Route Name"
                          persistent-hint
                          single-line hint="Enter the route name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=routetypes
                          v-model="new_route.routetype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the route type">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="locations.map(x => {
                            return {text: x.locationname, value: x._id};
                            })"
                          v-model="new_route.locationid"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="users.filter(i=>i.userstatus=='Active' && i.locationid==new_route.locationid).map(i=>{
                            return {text: i.username, value: i._id};
                            })"
                          v-model="new_route.repid"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Sales Rep"
                          persistent-hint
                          single-line hint="Please choose the sales rep">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-textarea
                          v-model="new_route.routedesc"
                          outlined
                          rows=4
                          label="Route Desc"
                          persistent-hint
                          hint="please enter the route description"
                        ></v-textarea>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row noGutters>
                    <v-col cols="12" md="12">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <div class="d-flex justify-center">
                          <v-btn
                              to="/route/list"
                              replace
                              outlined
                              color="primary"
                          >
                            Cancel
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertRoute()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      new_route: {},
      routetypes: ['Route', 'Other Route'],
      error: undefined,
      errorindex: undefined,
    }
  },
  computed: {
    ...mapState('Location', ['locations']),
    ...mapState('Route', ['isReceiving']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('Route', ['insertRouteRequest', 'getRoutesRequest']),
    ...mapActions('User', ['getUsersRequest']),
    checkError(){
      if(!this.new_route.routenum){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_route.routename){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.new_route.routetype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.new_route.locationid){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.new_route.repid){
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    async insertRoute() {
      if(!this.checkError()) return;
      await this.insertRouteRequest(this.new_route);
      router.push('/route/list');
    },
  },
  async created () {
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
